import { Popover } from '@mui/material'
// import { Link } from 'react-router-dom'

export const CreateListCrm = ({ idx, anchorEl, open, handleClose, createFrom }) => {

    return (
        <Popover
            className='p-popover-share'
            id={idx}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <div className='options'>
                {/* <a href="#" onClick={() => createFrom('cero')}>
                    <i className="bi bi-file-earmark-plus"></i>
                    <span>Crear desde cero</span>
                </a>
                <a href="#" onClick={() => createFrom('template')}>
                    <i className="bi bi-star"></i>
                    <span>Desde plantilla</span>
                </a> */}
                <button onClick={() => createFrom('cero')}>
                    <i className="bi bi-file-earmark-plus"></i>
                    <span>Crear desde cero</span>
                </button>
                <button onClick={() => createFrom('template')}>
                    <i className="bi bi-star"></i>
                    <span>Desde plantilla</span>
                </button>
            </div>
        </Popover >
    )
}